import { render, staticRenderFns } from "./address.vue?vue&type=template&id=2d58dc0e&scoped=true&lang=pug&"
import script from "./address.vue?vue&type=script&lang=ts&"
export * from "./address.vue?vue&type=script&lang=ts&"
import style0 from "./address.vue?vue&type=style&index=0&id=2d58dc0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d58dc0e",
  null
  
)

export default component.exports